import { ChangeDetectionStrategy, Component, computed, inject } from "@angular/core";

import {
  MscSubscriptionDetailsGQL,
  MscSubscriptionDetailsQuery,
} from "../../../../apis/networkdashboard/graphql/graphql";
import { serviceHealth } from "../../../../components/dashboard/service-health-signal/service-health-signal";
import { SubscriptionPageComponent } from "../../../../components/subscription-detail/subscription-page/subscription-page";
import { MscSubscriptionDetails } from "../../types";
import { GenericSubscription } from "../generic-subscription";
import { MscSubscriptionViewComponent } from "./msc-subscription-view";

@Component({
  selector: "msc-subscription",
  templateUrl: "msc-subscription.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MscSubscriptionViewComponent, SubscriptionPageComponent],
})
export class MscSubscriptionComponent extends GenericSubscription<MscSubscriptionDetailsQuery, MscSubscriptionDetails> {
  protected query = inject(MscSubscriptionDetailsGQL);

  private portSubscription = computed(() => this.subscription()?.portSubscription);
  protected override health = serviceHealth(this.portSubscription);
  protected override reportedStatus = computed(() => this.health().status);

  protected onQuerySuccess(data: MscSubscriptionDetailsQuery): MscSubscriptionDetails {
    return data.mscDetails;
  }
}
